import { Icon } from './Icon';

interface Props {
  open: boolean;
  onClose: () => void;
}

interface Group {
  title: string;
  items: { keys: string[]; desc: string }[];
}

const GROUPS: Group[] = [
  {
    title: 'General',
    items: [
      { keys: ['?'],                 desc: 'Open this shortcuts cheatsheet' },
      { keys: ['Cmd/Ctrl', 'S'],     desc: 'Save workflow' },
      { keys: ['Esc'],               desc: 'Close menus and dialogs' },
    ],
  },
  {
    title: 'Canvas',
    items: [
      { keys: ['F'],                 desc: 'Snap to fit · center the workflow' },
      { keys: ['Shift', 'Z'],        desc: 'Bird\'s-eye view · zoom way out' },
      { keys: ['Right-click'],       desc: 'Quick-add menu at cursor' },
      { keys: ['Mouse wheel'],       desc: 'Zoom in / out' },
      { keys: ['Space + drag'],      desc: 'Pan the canvas' },
    ],
  },
  {
    title: 'Editing',
    items: [
      { keys: ['Cmd/Ctrl', 'Z'],         desc: 'Undo last change' },
      { keys: ['Cmd/Ctrl', 'Shift', 'Z'], desc: 'Redo' },
      { keys: ['Cmd/Ctrl', 'C'],         desc: 'Copy selected node' },
      { keys: ['Cmd/Ctrl', 'V'],         desc: 'Paste node (via right-click)' },
      { keys: ['Backspace', '/', 'Delete'], desc: 'Delete selected node or edge' },
      { keys: ['Click'],                 desc: 'Select a node · open properties' },
    ],
  },
  {
    title: 'AI',
    items: [
      { keys: ['Click', '"Build with AI"'], desc: 'Open the AI chat assistant' },
      { keys: ['Right-click', '→', 'Build with AI'], desc: 'Open from context menu' },
      { keys: ['Drop', '"Ask AI" block'],   desc: 'Add an AI step inside the workflow' },
    ],
  },
];

export function ShortcutsOverlay({ open, onClose }: Props) {
  if (!open) return null;
  return (
    <div className="confirm-root" role="dialog" aria-modal="true" aria-label="Keyboard shortcuts">
      <div className="confirm-backdrop" onClick={onClose} />
      <div className="shortcuts-card">
        <div className="shortcuts-head">
          <div className="shortcuts-title">
            <span className="shortcuts-icon">
              <Icon name="menu" size={20} variant="silver" />
            </span>
            <div>
              <h3>Keyboard shortcuts</h3>
              <span>Everything you can do without touching the mouse</span>
            </div>
          </div>
          <button className="shortcuts-close" onClick={onClose} aria-label="Close">
            <Icon name="x" size={16} variant="muted" />
          </button>
        </div>

        <div className="shortcuts-grid">
          {GROUPS.map(g => (
            <div key={g.title} className="shortcuts-group">
              <h4>{g.title}</h4>
              <div className="shortcuts-list">
                {g.items.map((s, i) => (
                  <div className="shortcut-row" key={i}>
                    <div className="shortcut-keys">
                      {s.keys.map((k, ki) => (
                        <span key={ki}>
                          {ki > 0 && <span className="shortcut-plus">+</span>}
                          <kbd>{k}</kbd>
                        </span>
                      ))}
                    </div>
                    <span className="shortcut-desc">{s.desc}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="shortcuts-foot">
          <Icon name="help" size={12} variant="silver" />
          <span>Forgot a shortcut? Press <kbd>?</kbd> any time.</span>
        </div>
      </div>
    </div>
  );
}
